(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueAccountDialogController', QueueAccountDialogController);

    QueueAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueAccount'];

    function QueueAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueAccount) {
        var vm = this;

        vm.queueAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueAccount.id !== null) {
                QueueAccount.update(vm.queueAccount, onSaveSuccess, onSaveError);
            } else {
                QueueAccount.save(vm.queueAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtNascita = false;
        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.dtUpdate = false;
        vm.datePickerOpenStatus.recallDt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
